/**
 * Image Style registry — the visual treatment of imagery. Photographic
 * styles require the document to support images (Phase 2 knowledge);
 * drawn styles (illustration, vector, …) work anywhere icons/art can go.
 */

export const IMAGE_STYLES = [
  { id: 'photography', name: 'Photography', requiresCapabilities: ['supportsImages'] },
  { id: 'lifestyle', name: 'Lifestyle', requiresCapabilities: ['supportsImages'] },
  { id: 'studio', name: 'Studio', requiresCapabilities: ['supportsImages'] },
  { id: 'outdoor', name: 'Outdoor', requiresCapabilities: ['supportsImages'] },
  { id: 'cutout', name: 'Cutout', requiresCapabilities: ['supportsImages'] },
  { id: 'illustration', name: 'Illustration' },
  { id: 'vector', name: 'Vector' },
  { id: '3d', name: '3D' },
  { id: 'flat', name: 'Flat' },
  { id: 'watercolor', name: 'Watercolor' },
  { id: 'sketch', name: 'Sketch' },
];
